<template>
  <Popover
    placement="bottom"
    width="250"
    trigger="hover"
  >
    <Form
      ref="form"
      label-width="60px"
      :model="formData"
      :rules="rules"
    >
      <FormItem
        label="大于"
        prop="min"
      >
        <InputNumber
          v-model="formData.min"
          style="width: 80%"
          size="small"
        />
      </FormItem>
      <FormItem
        label="小于"
        prop="max"
      >
        <InputNumber
          v-model="formData.max"
          style="width: 80%"
          size="small"
        />
      </FormItem>
      <FormItem>
        <Button
          size="small"
          type="primary"
          @click="confirm"
        >
          确定
        </Button>
        <Button
          size="small"
          @click="reset"
        >
          重置
        </Button>
      </FormItem>
    </Form>
    <span slot="reference">
      <img
        class="icon"
        :src="filterIcon"
      >
    </span>
  </Popover>
</template>

<script>
import { Popover, Form, FormItem, InputNumber, Button } from 'element-ui';

import filterIcon from '@/assets/image/icon/filter-icon.png';

export default {
  components: {
    Popover,
    Form,
    FormItem,
    InputNumber,
    Button,
  },

  props: {
    // 字段类型
    type: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      formData: {
        min: undefined,
        max: undefined,
      },

      filterIcon,

      rules: {
        min: [{ required: true, message: '值不能为空', trigger: 'blur' }],
        max: [{ required: true, message: '值不能为空', trigger: 'blur' }],
      },
    };
  },

  methods: {
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { min, max } = this.formData;
          this.$emit('change', {
            type: this.type,
            min,
            max,
          });
        }
      });
    },

    reset() {
      this.formData = {
        min: undefined,
        max: undefined,
      };
      this.$emit('change', {
        type: this.type,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.icon {
  width: 10px;
}
</style>
